module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Max Silver.173267de.png";